import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';

import { openCashShift } from '../../../../services/merchantsService';

import { useToggle } from '../../../hooks/useToggle';
import { useLazyRequest } from '../../../hooks/useRequest';

import ButtonWithCirculaProgress from '../../ButtonWithCirculaProgress';
import DialogConfirmation from '../../DialogConfirmation';

import styles from './styles';

const useStyles = makeStyles(styles);

const ShiftWidgetOpenSection = ({ onCompleted }) => {
  const { t } = useTranslation('common');
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  const [
    showConfirmationOpenShift,
    toggleShowConfirmationOpenShift,
  ] = useToggle(false);

  const [, loadingOpenCashShift, , requestOpenCashShift] = useLazyRequest({
    request: openCashShift,
    withPostSuccess: () => {
      toggleShowConfirmationOpenShift(false);

      enqueueSnackbar(t('payments.shift.openCash.successMessage'), {
        variant: 'success',
      });

      onCompleted();
    },
    withPostFailure: (response) => {
      const message =
        response.errorData.message ?? t('payments.shift.openCash.errorMessage');

      enqueueSnackbar(message, { variant: 'error' });
    },
  });

  const handleOpenCashShift = useCallback(async () => {
    await requestOpenCashShift();
  }, [requestOpenCashShift]);

  return (
    <Box className={classes.container}>
      <ButtonWithCirculaProgress
        variant="contained"
        color="secondary"
        fullWidth
        loading={false}
        label={t('payments.shift.openCash.title')}
        className={classes.button}
        handleButtonClick={() => toggleShowConfirmationOpenShift(true)}
      />

      <DialogConfirmation
        open={showConfirmationOpenShift}
        description={t('payments.shift.openCash.confirmMessage')}
        onConfirm={handleOpenCashShift}
        onCancel={() => toggleShowConfirmationOpenShift(false)}
        loadingConfirm={loadingOpenCashShift}
      />
    </Box>
  );
};

ShiftWidgetOpenSection.propTypes = {
  onCompleted: PropTypes.func.isRequired,
};

export default ShiftWidgetOpenSection;
